// Lenovo India CSR — 4 focus areas
// Source: Lenovo India CSR programmes & partner portfolio (public domain)
// Palette: Red + Grey system (no blue). Pillars differentiated by red/grey luminance.

export const PILLARS = [
  {
    id: "stem",
    name: "STEM Education",
    short: "STEM",
    color: "#E2231A",        // Lenovo red
    accent: "#F87171",
    bg: "from-red-50 to-white",
    chipBg: "bg-red-50",
    chipText: "text-red-700",
    tagline: "Sparking curiosity through hands-on science & technology",
    description:
      "Experiential, lab-on-a-tab STEM learning for government-school students, paired with teacher enablement and vernacular content to make science joyful and accessible.",
    subThemes: [
      "Lab-on-a-Tab",
      "Experiential Science",
      "STEM Teacher Capacity",
      "Innovation Labs",
    ],
  },
  {
    id: "digital",
    name: "Digital Literacy",
    short: "DGL",
    color: "#1F2937",        // charcoal / dark grey
    accent: "#4B5563",
    bg: "from-slate-50 to-white",
    chipBg: "bg-slate-100",
    chipText: "text-slate-700",
    tagline: "Bridging the digital divide with 21st-century skills",
    description:
      "ICT literacy, coding, AI/ML exposure and tablet-based learning for government-school students — closing the digital-equity gap, especially for girls and rural learners.",
    subThemes: [
      "ICT Literacy",
      "Coding & AI",
      "Tablet Learning",
      "Govt-School Digital",
    ],
  },
  {
    id: "employability",
    name: "Employability & Skilling",
    short: "EMP",
    color: "#6B7280",        // mid slate grey
    accent: "#9CA3AF",
    bg: "from-gray-50 to-white",
    chipBg: "bg-gray-100",
    chipText: "text-gray-700",
    tagline: "Future-ready skills for first-generation job seekers",
    description:
      "Market-aligned skilling in IT-ITES and manufacturing, campus-to-corporate readiness and women-in-tech pathways that move youth into formal, dignified employment.",
    subThemes: [
      "IT-ITES Careers",
      "Women in Tech",
      "Campus to Corporate",
      "Vocational Skilling",
    ],
  },
  {
    id: "sustainability",
    name: "Sustainability",
    short: "SUS",
    color: "#991B1B",        // deep burgundy
    accent: "#DC2626",
    bg: "from-rose-50 to-white",
    chipBg: "bg-rose-50",
    chipText: "text-rose-800",
    tagline: "Responsible technology & resilient communities",
    description:
      "E-waste circularity, native tree plantation and agri-livelihood revival — lowering environmental impact while strengthening the communities Lenovo operates in.",
    subThemes: [
      "E-Waste & Recycling",
      "Tree Plantation",
      "Agri-Livelihoods",
      "Green Campuses",
    ],
  },
];

export const getPillar = (id) => PILLARS.find((p) => p.id === id);

// Global per-pillar beneficiary weights (used to split state totals by pillar)
export const PILLAR_WEIGHTS = {
  stem: 12000,
  digital: 9000,
  employability: 6000,
  sustainability: 4000,
};

// Shared grey → red sequential ramp for choropleth maps & heatmaps
export const CHOROPLETH_RAMP = [
  "#F3F4F6", "#FEE2E2", "#FECACA", "#FCA5A5", "#F87171",
  "#EF4444", "#E2231A", "#B91C1C", "#7F1D1D",
];
